import { createFileRoute } from '@tanstack/react-router'

import { ListPageHeader } from '@/components/common/ListPageHeader'
import { PostEditor } from '@/components/retail/cms/post-editor'
import { useAuth } from '@/hooks/use-auth'
import { useShopPost } from '@/hooks/use-shop-posts-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/retail/posts/$postId',
)({
    component: EditPostPage,
})

function EditPostPage() {
    const { postId } = Route.useParams()
    const { hasPermission } = useAuth()
    const query = useShopPost(postId)
    if (query.isLoading)
        return (
            <p className="page-pad text-muted-foreground">
                {m.common_loading()}
            </p>
        )
    const post = query.data?.data
    if (!post)
        return (
            <p className="page-pad text-destructive" role="alert">
                {m.cmsPost_not_found()}
            </p>
        )
    return (
        <div className="space-y-4 page-pad">
            <ListPageHeader title={post.fields.title} />
            {/* key: form nạp lại sau mỗi lần lưu (version mới). */}
            <PostEditor
                key={`${post.id}:${post.version}`}
                post={post}
                canWrite={hasPermission('shop_content.write')}
            />
        </div>
    )
}
